// extracted by css-extract-rspack-plugin
export default {"emptyState":"kfVtO","empyIcon":"oa9Si"};